import * as selectors from 'store/slices/cars/selectors';
import * as actions from 'store/slices/cars/actions';
import { carsSlice } from './cars.slice';

export const carsActions = {
  ...carsSlice.actions,
  ...actions,
};

export const carsSelectors = {
  ...selectors,
};
